import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  static values = {};

  connect() {
    // console.log("Hello, Stories Interview Templates Controller here!", this.element);
  }

  duplicate(event) {
    event.preventDefault();
    event.target.innerText = 'Duplicating...';
    $.ajax({
      url: `/interview_templates/${event.params.id}/duplicate`,
      type: 'POST',
      success: function(data) {
        console.log(data);

        document.cookie = `flash_notice=Template duplicated; path=/`;
        window.location.reload();
      },
      error: function(xhr, status, error) {
        event.target.innerText = 'Error';
        console.log(xhr.responseText);
      }
    });
  }
}
